import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Modal, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledTitle = styled(Paragraph)`
  margin-bottom: ${convertUnit(16)};
`
const StyledModal = styled(Modal)`
  width: 100%;
  max-width: ${convertUnit(335)};
  padding: ${convertUnit(20)};
  text-align: center;
`
const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${convertUnit(20)};
  gap: ${convertUnit(20)};
`
const StyledButton = styled(Button)`
  width: fill-available;
`

interface GiftShopTemplateModalMFARecoverProps {
  onToggle(): void
  onConfirm(): void
}
export default function GiftShopTemplateModalMFARecover({
  onToggle,
  onConfirm,
}: GiftShopTemplateModalMFARecoverProps) {
  const {translate} = useTranslation()

  return (
    <StyledModal visible onBackdropPress={onToggle}>
      <StyledTitle fontSize="xl" fontWeight="bold">
        {translate('giftShop:settingAuthAppRecoveryModalTitle')}
      </StyledTitle>
      <Paragraph fontSize="l">
        {translate('giftShop:settingAuthAppRecoveryModalDesc')}
      </Paragraph>
      <StyledButtonContainer>
        <StyledButton
          label={translate('global:cancel')}
          color="primary_5"
          backgroundColor="white_3"
          onClick={onToggle}
        />
        <StyledButton
          label={translate('global:continue')}
          onClick={() => {
            onToggle()
            onConfirm()
          }}
        />
      </StyledButtonContainer>
    </StyledModal>
  )
}
